export enum FeatureLabelTheme {
    NEW = 'new',
    NEUTRAL = 'neutral',
    PROMO = 'promo',
}
